import { useCallback, useEffect } from 'react';
import { Routes, Route, useMatch, useNavigate, useLocation, matchRoutes } from 'react-router-dom';

import Account from '@pages/accountSettings/Account';
import Team from '@pages/accountSettings/Team';
import Payment from '@pages/accountSettings/Payment';
import PlanNUpgrade from '@pages/accountSettings/Plan&Upgrade';

const accountSettingsTabs = [
  { pathNameIndex: 'account', tabText: 'Account' },
  { pathNameIndex: 'team', tabText: 'Team' },
  { pathNameIndex: 'payment', tabText: 'Payment' },
  { pathNameIndex: 'plan&upgrade', tabText: 'Plan & Upgrade' },
];

const AccountSettingsRoutes = () => {
  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    if (location) {
      console.log('location: ', location);
      const matchroutesTest = matchRoutes([{ path: '/appManager/myApps/*' }], location);
      console.log('matchroutesTest: ', matchroutesTest);
    }
  }, [location]);

  const onClickNavigate = useCallback(
    (path: string) => {
      if (path === 'account') {
        navigate('/accountSettings/account');
      } else if (path === 'team') {
        navigate('/accountSettings/team');
      } else if (path === 'payment') {
        navigate('/accountSettings/payment');
      } else if (path === 'plan&upgrade') {
        navigate('/accountSettings/plan&upgrade');
      }
    },
    [navigate]
  );
  return (
    <div className="tab-menu">
      <ul className="tab-wrap">
        {accountSettingsTabs.map((item, index) => (
          <li
            key={index}
            className={`tab-list ${
              location?.pathname.split('/')[location?.pathname.split('/').length - 1] === item.pathNameIndex
                ? 'active'
                : ''
            } `}
          >
            <button type="button" className="tab-btn" onClick={() => onClickNavigate(item.pathNameIndex)}>
              {item.tabText}
            </button>
          </li>
        ))}
        {/* <li className={`tab-list ${location?.pathname.indexOf('/account') > -1 ? 'active' : ''} `}>
          <button type="button" className="tab-btn" onClick={() => onClickNavigate('account')}>
            Account
          </button>
        </li>
        <li className={`tab-list ${location?.pathname.indexOf('/team') > -1 ? 'active' : ''}`}>
          <button type="button" className="tab-btn" onClick={() => onClickNavigate('team')}>
            Team
          </button>
        </li> */}
      </ul>

      <Routes>
        <Route path="/account" element={<Account />} />
        <Route path="/team" element={<Team />} />
        <Route path="/payment" element={<Payment />}></Route>
        <Route path="/plan&upgrade" element={<PlanNUpgrade />} />
      </Routes>
    </div>
  );
};

export default AccountSettingsRoutes;
